import { t } from 'i18next';
import apiDBVariableMapping from './apiDBVariableMapping';

const apiDBErrorMessage = (error) => {
  let errorMessage = t('ErrorMessage');
  if (error.Message && error.ErrorCode) {
    switch (error.StatusCode) {
      case 'HTTP_500':
        errorMessage = t('ErrorMessageServerError');
        break;
      case 'HTTP_400': {
        errorMessage = '';
        const codes = error.ErrorCode.split(',');
        const messages = error.Message.split(',');
        let index = 0;
        codes.forEach((code) => {
          const message = messages[index];
          const splitMessage = message.split(' ')[0] === ('address'
            || 'addressLine1' || 'addressAdditional' || 'billTo' || 'city'
            || 'commodityCode' || 'companyName' || 'contactName' || 'country' || 'declaredValue'
            || 'description' || 'email' || 'postalZipCode' || 'province' || 'phoneNumber'
            || 'unNumber' || 'length' || 'width' || 'height' || 'UNCode')
            ? message.split(' ')[0] : message;
          const field = apiDBVariableMapping(splitMessage);
          switch (code) {
            case 'belowMinValue': {
              // Message: {field} cannot be less than the minimum value of {value}.
              const minValues = message.match(/\d+/g);
              const minValue = minValues[minValues.length - 1];
              errorMessage += `${t('ErrorMessageBelowMinValue').replace('{field}', field).replace('{value}', minValue)} `;
              break;
            }

            case 'exceedsMaxLength': {
              // Message: {field} is expected to not exceed maximum length of {value} character(s).
              const maxValues = message.match(/\d+/g);
              const maxValue = maxValues[maxValues.length - 1];
              errorMessage += `${t('ErrorMessageExceedsMaxLength').replace('{field}', field).replace('{value}', maxValue)} `;
              break;
            }

            case 'invalidString':
              // Message: {field} is expected to be a valid string.
              errorMessage += `${t('ErrorMessageInvalidString').replace('{field}', field)} `;
              break;
            case 'missingRequiredField':
              // Message: {field} is a required field.
              errorMessage += `${t('ErrorMessageMissingRequiredField').replace('{field}', field)} `;
              break;
            case 'invalidDBValue':
            case 'badRequest':
              // Message: {field} is not a valid {label}.
              if (message.split(' ')[0] === ('address'
                || 'addressLine1' || 'addressAdditional' || 'billTo' || 'city'
                || 'commodityCode' || 'companyName' || 'contactName' || 'country' || 'declaredValue'
                || 'description' || 'email' || 'postalZipCode' || 'province' || 'phoneNumber'
                || 'unNumber' || 'length' || 'width' || 'height' || 'UNCode')) {
                errorMessage += `${t('ErrorMessageInvalidDBValue').replace('{field}', field)} `;
              } else {
                errorMessage = message;
              }

              break;
            default:
              break;
          }

          index++;
        });
        errorMessage = errorMessage.trim();
        break;
      }

      default:
        break;
    }
  }

  return errorMessage;
};

export default apiDBErrorMessage;
